/*import {
    Box,
    Tabs,
    Tab,
    Typography,
    Container,
    Card,
    CardContent,
    TextField,
    Switch,
    FormControlLabel,
    Stack,
    Chip,
    Button,
    Table,
    Link,
    TableBody,
    TableCell,
    TableContainer,
    TableRow,
    FormGroup,
    FormControl,
    FormLabel,
    RadioGroup,
    Radio,
    Alert,
    IconButton,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Dialog,
    Fab,
    Tooltip,
    Collapse,
    Divider,
    Grid,
    CircularProgress,
    Autocomplete,
} from "@mui/material";
import Paper from "@mui/material/Paper";
import {useDispatch, useSelector} from "react-redux";
import {
    changeDiffFlag,
    changeSdhHourPrice, changeShowCarTable, changeShowClientTable,
    changeShowComplexity,
    changeShowCompanyInfo,
    changeShowLogoOnLeft,
    changeOrganization,
    changeCompanyName,
    changeCompanyTin,
    changeCompanyAddress,
    changeCompanyPhoneNumber,
    changeCompanyLogoObjectUrl,
    changeShowFromAccount,
    VATs,
    changeVAT,
    pushVATOption,
    popVATOption,
    MaxVATOptionsCount,
    changeUpdateWorkFlag,
    changeMileageType
} from "../redux/settingsSlice";
import BookIcon from "@mui/icons-material/BookOutlined";
import {Form, Formik} from "formik";
import InfoIcon from "@mui/icons-material/InfoOutlined";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/DeleteOutline"
import CloseIcon from "@mui/icons-material/Close"
import SaveIcon from "@mui/icons-material/Save"
import DoneAllIcon from "@mui/icons-material/DoneAll"
import AccessTimeIcon from "@mui/icons-material/AccessTime"
import React, {useEffect, useState, useCallback} from "react";
import {
    addFriend,
    confirmFriend,
    deleteFriend,
    getFriendRequests,
    getFriends,
    getPendingFriends,
    setShowCompanyInfo,
    setShowFromAccount,
    setShowLogoOnLeft,
    setOrganization,
    setCompanyName,
    setCompanyTin,
    setCompanyAdress,
    setCompanyPhoneNumber,
    setCompanyLogo,
    getOrganization,
    getCompanyTin,
    loadPrintSettings,
    deletePendingFriend,
} from "../serverREST";
import {ImageInput} from './settingsParts/ImageInput.js'
import debounce from "../utils/debounce.js";
import {sumWithVAT, vatString, vatFromSum} from "./calculatorParts/TableSums.js";
import {Cancel, HelpOutline} from "@mui/icons-material";
import {NumericField} from "./calculatorParts/NumberField.js";
import {useTranslation} from 'react-i18next';

const TooltipText = 'Впишите email ваших партнеров  (учетной записи в MotorData Нормы времени)  для объединения и общего использования списков собственных работ.';


function AddFriendFrom({setOpenAddFriend, onSave, onError}) {
    const friends = useSelector(state => state.friends.friends);
    const pendingFriends = useSelector(state => state.friends.pendingFriends);
    const userEmail = useSelector(state => state.account.login);

    const existsEmails = new Set([
        ...friends.map(f => f.login),
        ...pendingFriends.map(f => f.login),
    ]);

    return (

        <Formik
            initialValues={{
                friendEmail: '',
            }}

            onSubmit={
                (values) => {
                    setOpenAddFriend(false);

                    const email = values.friendEmail ? values.friendEmail.trim() : null;

                    if (email && email !== userEmail) {
                        if (existsEmails.has(email)) {
                            onError && onError(409); // 409 Conflict
                        } else {
                            addFriend(email, (isAdded, status) => {
                                isAdded ? (onSave && onSave()) : (onError && onError(status));
                            });
                        }
                    }
                }
            }>
            {({setFieldValue, values}) => (
                <Form>
                    <Stack sx={{mt: 1}} direction={'row'} justifyContent='space-between'>
                        <TextField
                            size={'small'}
                            autoFocus={true}
                            value={values.friendEmail}
                            sx={{mr: 1, flexGrow: 1}}
                            label={'Email партнёра'}
                            onChange={
                                (event) => {
                                    setFieldValue('friendEmail', event.target.value)
                                }}
                        >
                        </TextField>

                        <IconButton
                            size="medium"
                            color="secondary"
                            aria-label="menu"
                            onClick={() => {
                                setOpenAddFriend(false)
                            }}
                        >
                            <CloseIcon/>
                        </IconButton>

                        <IconButton
                            size="medium"
                            color="secondary"
                            aria-label="menu"
                            type={'submit'}
                        >
                            <SaveIcon/>
                        </IconButton>
                    </Stack>

                </Form>
            )}
        </Formik>

    );
}

function FriendRequestDialog({username}) {
    const [open, setOpen] = useState(true);
    const [wait, setWait] = useState(false);
    const [hasError, setHasError] = useState(false);

    const handleConfirm = () => {
        setWait(true);
        confirmFriend(username, 'accept', (accepted) => {
            setWait(false);
            accepted ? setOpen(false) : setHasError(true);
        });
    };

    const handleDecline = () => {
        confirmFriend(username, 'decline');
        setOpen(false);
    };

    const fadeInAnim = {
        opacity: 0,
        animation: 'fadeIn 0.5s ease-in-out 1s forwards',
        '@keyframes fadeIn': {
            '0%': {opacity: 0},
            '100%': {opacity: 1},
        },
    };

    return (
        <Dialog
            open={open}
            onClose={() => setOpen(false)}
        >
            <DialogTitle>
                Запрос дружбы
            </DialogTitle>
            <DialogContent>
                {!hasError
                    ?
                    <DialogContentText>
                        Вам поступил запрос в друзья от пользователя <b>{username}</b>. Желаете подтвердить запрос или
                        отклонить?
                        Подтвердив запрос, вы объедините выдачу собственных работ с дружественным автосервисом.
                    </DialogContentText>
                    :
                    <DialogContentText>Приглашение не найдено</DialogContentText>
                }
            </DialogContent>
            {!hasError
                ?
                <DialogActions>
                    {wait && <CircularProgress sx={{mr: 1, ...fadeInAnim}} size={24}/>}
                    <Button onClick={handleConfirm} disabled={wait}>
                        Подтвердить
                    </Button>
                    <Button onClick={handleDecline} disabled={wait}>
                        Отклонить
                    </Button>
                </DialogActions>
                :
                <DialogActions>
                    <Button onClick={() => setOpen(false)}>
                        Закрыть
                    </Button>
                </DialogActions>
            }

        </Dialog>
    );
}

function FriendEntry(props) {
    const {email, accepted, user_code, user_num} = props;
    const isAccepted = Boolean(accepted);

    const AcceptedFriendTooltip = () => (
        <Tooltip title='Автосервис подтвердил Вашу заявку и объединил с Вами выдачу своих работ'>
            <DoneAllIcon color="success"/>
        </Tooltip>
    );
    const WaitedFriendTooltip = () => (
        <Tooltip title='Автосервис пока не подтвердил Вашу заявку'>
            <AccessTimeIcon color="warning"/>
        </Tooltip>
    );

    return (
        <Stack sx={{justifyContent: 'space-between'}} direction={'row'} alignItems={'center'}>
            <Stack direction={'row'} alignItems={'center'}>
                {isAccepted ? <Box style={{
                        "display": "flex",
                        "gap": "4px",

                    }}>
                        <AcceptedFriendTooltip/>
                        <Box style={{
                            "padding": "0px 2px",
                            "backgroundColor": `#${user_code}`,
                            "color": "white",
                            "alignItems": "center",
                            "display": "flex",
                            "borderRadius": "2px"
                        }}>
                            <Typography variant='body2' fontSize={13}>
                                {user_num}
                            </Typography>
                        </Box>
                    </Box>
                    : <WaitedFriendTooltip/>}
                <Typography sx={{m: 1}}> {email} </Typography>
            </Stack>

            <IconButton
                size="medium"
                color="secondary"
                aria-label="menu"
                onClick={() => isAccepted ? deleteFriend(email) : deletePendingFriend(email)}
            >
                <DeleteIcon/>
            </IconButton>
        </Stack>
    );
}

function TimeoutAlert({open, setOpen, severity, text, duration}) {
    const _duration = duration ? duration : 3000;

    useEffect(() => {
        if (open) {
            const timeout = setTimeout(() => setOpen(false), _duration);
            return () => clearTimeout(timeout);
        }
    }, [open]);

    return (
        <Collapse in={open} unmountOnExit>
            <Alert
                severity={severity}
                onClose={() => setOpen(false)}
                sx={{mt: 1}}
            >
                {text}
            </Alert>
        </Collapse>
    );
};

function Friends() {
    useEffect(() => {
        getFriends();
        getFriendRequests();
        getPendingFriends();
    }, []);

    const [openAddFriend, setOpenAddFriend] = useState(false);
    const [addFriendAlert, setAddFriendAlert] = useState(false);
    const [onConflictAlert, setOnConflictAlert] = useState(false);

    const friends = useSelector(state => state.friends.friends);
    const pendingFriends = useSelector(state => state.friends.pendingFriends);
    const friendRequests = useSelector(state => state.friends.friendRequests);

    const licenseEnded = useSelector(state => state.license.licenseEnded);
    const licenseCountEnded = useSelector(state => state.license.licenseCountEnded);
    const licenseDayCountEnded = useSelector(state => state.license.licenseDayCountEnded);

    const canAddFriends = !licenseEnded && !licenseCountEnded && !licenseDayCountEnded;
    //console.log({friends})
    return (
        <Box sx={{ml: 2, maxWidth:"900px"}} >
            <Typography
                sx={{mt: 0, p: 2, backgroundColor: 'rgb(237, 246, 254)'}}
                textAlign='justify'
                variant='body1'
            >
                <IconButton
                    disableRipple
                    size={'small'}
                    sx={{pb: 0, pt: 0, color: 'rgb(77, 171, 245)', cursor: 'default'}}>
                    <InfoIcon fontSize={'small'}/>
                </IconButton>
                {TooltipText}
            </Typography>

            <Paper sx={{width: '100%', mt: 1}}>
                <Box sx={{p: 1}}>
                    <Stack>
                        {friends.map((friend, index) =>
                            <FriendEntry
                                key={index}
                                email={friend.login}
                                user_code={friend.user_code}
                                user_num={friend.user_num}
                                accepted
                            />
                        )}
                        {pendingFriends.map((friend, index) =>
                            <FriendEntry
                                key={index}
                                email={friend.login}
                            />
                        )}
                        {!licenseEnded &&
                            friendRequests.map((friend, index) => {
                                return (
                                    <FriendRequestDialog key={index} username={friend.login}/>
                                )
                            })
                        }
                    </Stack>
                    <Button
                        sx={{width: '100%'}}
                        variant={'outlined'}
                        startIcon={<AddIcon/>}
                        disabled={!canAddFriends}
                        onClick={() => setOpenAddFriend(true)}
                    >
                        {'Добавить партнёра'}
                    </Button>
                    {!canAddFriends &&
                        <Stack spacing={1}>
                            <Alert sx={{mt: 1, pl: 1}} severity="warning">
                                {'Добавить партнёра можно только при наличии активной лицензии'}
                            </Alert>
                            <Link sx={{ml: 1}} href={'../../purchase/tariffs'} underline={'none'} variant={'subtitle1'}>Купить
                                лицензию</Link>
                        </Stack>
                    }
                    <Collapse in={openAddFriend} unmountOnExit>
                        <AddFriendFrom
                            setOpenAddFriend={setOpenAddFriend}
                            onSave={() => setAddFriendAlert(true)}
                            onError={(status) => {
                                (status === 409) && setOnConflictAlert(true);
                            }}
                        />
                    </Collapse>
                    <TimeoutAlert
                        open={addFriendAlert}
                        setOpen={setAddFriendAlert}
                        duration={5000}
                        severity='success'
                        text={'Если пользователь с указанным email существует, он сможет принять приглашение.'}
                    />
                    <TimeoutAlert
                        open={onConflictAlert}
                        setOpen={setOnConflictAlert}
                        duration={5000}
                        severity='error'
                        text={'Пользователь с указанным email уже является партнёром или приглашение уже отправлено. Обновите страницу.'}
                    />
                </Box>
            </Paper>

            <Typography sx={{m: 0, mt: 2}} variant={'h5'}>Информация</Typography>

            <Box sx={{m: 0, p: 2, pt: 1, backgroundColor: 'rgb(237, 246, 254)'}}>
                <Typography variant={'body1'} sx={{mt: 1}}>
                    <IconButton
                        disableRipple
                        size={'small'}
                        sx={{pb: 0, pt: 0, color: 'rgb(77, 171, 245)', cursor: 'default'}}
                    >
                        <InfoIcon fontSize={'small'}/>
                    </IconButton>
                    {
                        `Вы можете производить поиск по 2 или более словам, набирая только начальные буквы слов.
                         Например, набрав "охл ж" можно быстро найти Охлаждающую жидкость.`
                    }
                </Typography>
                <Typography variant={'body1'} sx={{mt: 1}}>
                    Обратите внимание, что представленные в каталоге нормативы на замену жидкостей (масел)
                    <strong> одинаковы для всех автомобилей</strong>. Если Вы хотите изменить существующий норматив или
                    создать новый, то Вы можете это сделать самостоятельно,
                    используя универсальный каталог деталей/жидкостей/процедур. Созданные Вами нормативы будут
                    сохранены и будут показываться Вам при каждом входе в эту модель в отдельном разделе
                    "Собственные нормативы", расположенном в нижней части каталога.
                    А при поиске собственный норматив будет помечен спецсимволом
                    <IconButton size={'small'} color={'secondary'}>
                        <BookIcon fontSize={'small'}/>
                    </IconButton>
                </Typography>
            </Box>
        </Box>
    )
}

const VATSettings = ({title, vatKey, useOptions}) => {
    const vat = useSelector(state => state.settings.vats[vatKey]);
    const canAddOptions = Boolean(useOptions);

    const dispatch = useDispatch();

    return (
        <FormControl>
            <FormControlLabel
                label={title}
                control={
                    <Switch
                        checked={vat.active}
                        onChange={(event) => {
                            dispatch(changeVAT({key: vatKey, active: event.target.checked}));
                        }}
                    />
                }
            />
            <Collapse in={vat.active} unmountOnExit sx={{ml: 2, pt: 2}}>
                <Formik
                    initialValues={{value: vat.value}}
                    onSubmit={(values) => {
                        const value = Number(Number(values.value).toFixed(2));

                        if (value !== vat.value) {
                            dispatch(changeVAT({key: vatKey, value: value}));
                        }
                    }}
                >
                    {({setFieldValue, values, handleSubmit}) => (
                        <Form onSubmit={handleSubmit}>
                            <VATNumberField
                                label={canAddOptions ? 'Значение НДС по умолчанию (%)' : "Значение НДС (%)"}
                                value={values.value}
                                onValueChange={(value) => setFieldValue('value', value)}
                                onBlur={handleSubmit}
                            />
                        </Form>
                    )}
                </Formik>
                {canAddOptions &&
                    <VATOptions vatKey={vatKey} vat={vat}/>
                }
                <VATTypeSetings vatKey={vatKey}/>
            </Collapse>
        </FormControl>
    );
};
const VATOptions = ({vatKey, vat}) => {
    const [open, setOpen] = useState(false);

    const dispatch = useDispatch();

    const hasOptions = vat.options.length > 0;
    const canAddOption = vat.options.length < MaxVATOptionsCount;
    const options = [...vat.options].sort((a, b) => a - b);

    return (
        <Box>
            {hasOptions &&
                <Stack direction='row' flexWrap='wrap' sx={{mt: 1, maxWidth: 450}}>
                    {options.map((option) => (
                        <Chip
                            variant='outlined'
                            sx={{
                                m: '2px', ml: 0, mr: '4px',
                                borderRadius: 1,
                            }}
                            key={option}
                            label={
                                <Typography>{`${option}%`}</Typography>
                            }
                            onDelete={() => {
                                dispatch(popVATOption({
                                    key: vatKey,
                                    option: Number(option),
                                }))
                            }}
                            deleteIcon={<Cancel/>}
                        />
                    ))}
                </Stack>
            }
            {open
                ?
                <Formik
                    initialValues={{
                        value: null,
                    }}
                    onSubmit={(values) => {
                        setOpen(false);

                        if (values.value !== null) {
                            dispatch(pushVATOption({
                                key: vatKey,
                                option: Number(values.value),
                            }))
                        }
                    }}
                >
                    {({setFieldValue, values, handleSubmit}) => (
                        <Form>
                            <Stack sx={{mt: 1}} direction='row'>
                                <VATNumberField
                                    id='custom-vat-input'
                                    value={values.value}
                                    emptyValue={null}
                                    showEmptyValue={false}
                                    onValueChange={(value) => setFieldValue('value', value)}
                                    onBlur={() => setOpen(false)}
                                />
                                <IconButton
                                    size="medium"
                                    color="secondary"
                                    type="submit"
                                    onMouseDown={(e) => {
                                        e.preventDefault();
                                        handleSubmit();
                                    }}
                                >
                                    <SaveIcon/>
                                </IconButton>
                            </Stack>
                        </Form>
                    )}
                </Formik>
                :
                <Box style={{display: "flex", gap: "10px", alignItems: "center"}}>
                    <Button
                        sx={{
                            mt: 1,
                        }}
                        disabled={!canAddOption}
                        variant={'outlined'}
                        startIcon={<AddIcon/>}
                        onClick={() => {
                            setOpen(true);
                            setTimeout(() => document.getElementById('custom-vat-input')?.focus(), 10);
                        }}
                    >
                        {'Добавить значение'}
                    </Button>
                    <Tooltip
                        style={{marginTop: "8px"}}
                        title={'Значение будет доступно для выбора при добавлении детали в заказ-наряд '}
                        arrow
                        placement="right"
                        componentsProps={{
                            tooltip: {sx: {fontSize: "16px"}},
                        }}
                    >
                        <HelpOutline fontSize={'small'} sx={{color: 'gray'}}/>
                    </Tooltip>
                </Box>
            }
        </Box>
    );
};

const VATTypeSetings = ({vatKey}) => {
    const vat = useSelector(state => state.settings.vats[vatKey]);
    return (
        <React.Fragment>
            <RadioGroup>
                <VATRadioControll text={'НДС в сумме'} vatKey={vatKey} vat={vat} value={0}/>
                <VATRadioControll text={'НДС сверху'} vatKey={vatKey} vat={vat} value={1}/>
            </RadioGroup>
        </React.Fragment>
    );
};

const VATRadioControll = ({text, vatKey, vat, value}) => {
    const dispatch = useDispatch();

    const handleTypeChange = (event) => {
        const newType = Number(event.target.value);

        dispatch(changeVAT({key: vatKey, type: newType}));
    };

    return (
        <FormControlLabel
            control={
                <Radio
                    checked={vat.type === value}
                    value={value}
                    onChange={handleTypeChange}
                />
            }
            label={
                <Stack direction='row' spacing={1}>
                    <Typography>{text}</Typography>
                    <VATExampleTooltip vatType={value}/>
                </Stack>
            }
        />
    );
};

const VATExampleTooltip = ({vatType}) => {
    return (
        <Tooltip
            title={<VATExample vatType={vatType}/>}
            arrow
            placement="right"
            componentsProps={{
                tooltip: {sx: {borderRadius: 3}},
            }}
        >
            <HelpOutline fontSize={'small'} sx={{color: 'gray'}}/>
        </Tooltip>
    );
};

const VATExample = ({vatType}) => {
    const xs1 = 7;
    const sum = 10000;
    const vat = {active: true, type: vatType, value: 20};

    const data = [
        {title: 'Сумма', value: sum},
        {title: `НДС ${vatString(vat)}`, value: vatFromSum(sum, vat)},
        vatType === 0
            ? {title: 'Сумма без НДС', value: sumWithVAT(sum, vat) - vatFromSum(sum, vat)}
            : {title: 'Сумма с НДС', value: sumWithVAT(sum, vat)},
    ];

    return (
        <Grid container sx={{width: 250}}>
            <Grid item xs={12}>
                <Typography>
                    {vatType === 0
                        ? 'НДС будет выделен из суммы.'
                        : 'НДС будет начислен к сумме.'
                    }
                </Typography>
                <Typography> {'Пример:'} </Typography>
            </Grid>
            {data.map((item, index) => (
                <React.Fragment key={index}>
                    <Grid item xs={xs1}>
                        <Typography> {item.title} </Typography>
                    </Grid>
                    <Grid item xs={12 - xs1}>
                        <Typography> {item.value} </Typography>
                    </Grid>
                </React.Fragment>
            ))}
        </Grid>
    );
};

function VATNumberField(props) {
    return (
        <NumericField
            emptyValue={0}
            showEmptyValue
            {...props}
            size="small"
            InputProps={{inputProps: {min: 0, max: 100, step: 'any', autoComplete: 'off'}}}
            allowNegative={false}
            decimalScale={2}
            onValueChange={(value) => {
                props.onValueChange && props.onValueChange(value);
            }}
        />
    );
}

function PrintSettings({}) {
    const hasPrintSettings = useSelector(state => state.settings.hasPrintSettings);

    const showComplexity = useSelector(state => state.settings.showComplexity);
    const showCarTable = useSelector(state => state.settings.showCarTable);
    const showClientTable = useSelector(state => state.settings.showClientTable);

    const showCompanyInfo = useSelector(state => state.settings.showCompanyInfo);
    const showFromAccount = useSelector(state => state.settings.showFromAccount);
    const showLogoOnLeft = useSelector(state => state.settings.showLogoOnLeft);
    const companyPhoneNumber = useSelector(state => state.settings.companyPhoneNumber);
    const organization = useSelector(state => state.settings.organization);
    const companyName = useSelector(state => state.settings.companyName);
    const companyTin = useSelector(state => state.settings.companyTin);
    const companyAddress = useSelector(state => state.settings.companyAddress);
    const companyLogoObjectUrl = useSelector(state => state.settings.companyLogoObjectUrl);

    const phonePattern = "/^\+?[0-9()\- ]*";
    const phoneRegex = /^\+?[0-9()\- ]*$/;

    const dispatch = useDispatch();

    const updatePrintSettings = () => {
        if (!hasPrintSettings) {
            loadPrintSettings();
        }
    };

    useEffect(() => {
        updatePrintSettings();
    }, []);

    const debounceSendPhone = useCallback(
        debounce((value) => setCompanyPhoneNumber(value), 1000),
        [],
    );
    const debounceSendName = useCallback(
        debounce((value) => setCompanyName(value), 1000),
        [],
    );
    const debounceSendTin = useCallback(
        debounce((value) => setCompanyTin(value), 1000),
        [],
    );
    const debounceSendAdress = useCallback(
        debounce((value) => setCompanyAdress(value), 1000),
        [],
    );
    const debounceSendOrganization = useCallback(
        debounce((value) => setOrganization(value), 1000),
        [],
    );

    return (
        <React.Fragment>
            <Typography sx={{mt: 1}} variant={'h5'} align='left'>
                {'Настройки печати'}
            </Typography>
            <Paper sx={{width: '100%', p: 1}}>
                <FormGroup>
                    <FormControlLabel
                        label="Показать коэф. сложности"
                        control={
                            <Switch
                                checked={showComplexity}
                                onChange={(e) => dispatch(changeShowComplexity(e.target.checked))}
                            />
                        }
                    />
                </FormGroup>
                <FormGroup>
                    <FormControlLabel
                        label="Показать таблицу доп. данных об автомобиле"
                        control={
                            <Switch
                                checked={showCarTable}
                                onChange={(e) => dispatch(changeShowCarTable(e.target.checked))}
                            />
                        }
                    />
                </FormGroup>
                <FormGroup>
                    <FormControlLabel
                        label="Показать таблицу данных клиента"
                        control={
                            <Switch
                                checked={showClientTable}
                                onChange={(e) => dispatch(changeShowClientTable(e.target.checked))}
                            />
                        }
                    />
                </FormGroup>
                <FormGroup>
                    <FormControlLabel
                        label="Показать данные автосервиса"
                        control={
                            <Switch
                                checked={showCompanyInfo}
                                onChange={(e) => {
                                    if (e && e.target && e.target.checked !== undefined) {
                                        dispatch(changeShowCompanyInfo(e.target.checked));
                                        setShowCompanyInfo(e.target.checked).then(() => {
                                            updatePrintSettings();
                                        });
                                    }
                                }}
                            />
                        }
                    />
                </FormGroup>
                <Collapse in={showCompanyInfo}>
                    <Stack
                        direction='column'
                        sx={{m: 2}}
                        spacing={{xs: 1}}
                    >
                        <FormGroup>
                            <FormControlLabel
                                label="Заполнить из личного кабинета"
                                control={
                                    <Switch
                                        checked={showFromAccount}
                                        onChange={(e) => {
                                            const value = e.target.checked;

                                            dispatch(changeShowFromAccount(value));
                                            setShowFromAccount(value);

                                            getOrganization(value);
                                            getCompanyTin(value);
                                        }}
                                    />
                                }
                            />
                        </FormGroup>
                        <TextField
                            size="small"
                            label='Организация'
                            value={organization}
                            disabled={showFromAccount}
                            onChange={(e) => {
                                dispatch(changeOrganization(e.target.value));
                                debounceSendOrganization(e.target.value);
                            }}
                        />
                        <TextField
                            size="small"
                            label='Название автосервиса'
                            value={companyName}
                            onChange={(e) => {
                                dispatch(changeCompanyName(e.target.value));
                                debounceSendName(e.target.value);
                            }}
                        />
                        <TextField
                            size="small"
                            label='ИНН'
                            inputProps={{maxLength: 12}}
                            value={companyTin}
                            disabled={showFromAccount}
                            onChange={(e) => {
                                const value = e.target.value;
                                const filtered = value.replace(/[^0-9]/g, '');

                                dispatch(changeCompanyTin(filtered));
                                debounceSendTin(filtered);
                            }}
                        />
                        <TextField
                            size="small"
                            label='Адрес'
                            value={companyAddress}
                            onChange={(e) => {
                                dispatch(changeCompanyAddress(e.target.value));
                                debounceSendAdress(e.target.value);
                            }}
                        />
                        <TextField
                            size='small'
                            label='Телефон автосервиса'
                            inputProps={{pattern: phonePattern, maxLength: 25}}
                            value={companyPhoneNumber}
                            onChange={(event) => {
                                const value = event.target.value;
                                if (phoneRegex.test(value)) {
                                    dispatch(changeCompanyPhoneNumber(value));
                                    debounceSendPhone(value);
                                }
                            }}
                        />
                        <ImageInput
                            valueObjectURL={companyLogoObjectUrl}
                            allowedTypes='image/png'
                            maxSizeMb={1}
                            onChangeFile={(file) => {
                                if (file) {
                                    dispatch(changeCompanyLogoObjectUrl(URL.createObjectURL(file)));
                                    setCompanyLogo(file);
                                } else {
                                    dispatch(changeCompanyLogoObjectUrl(null));
                                    setCompanyLogo(null);
                                }
                            }}
                        />
                        <FormGroup>
                            <FormControlLabel
                                label="Расположить логотип с левого края страницы"
                                control={
                                    <Switch
                                        checked={showLogoOnLeft}
                                        onChange={(e) => {
                                            if (e && e.target && e.target.checked !== undefined) {
                                                dispatch(changeShowLogoOnLeft(e.target.checked))
                                                setShowLogoOnLeft(e.target.checked);
                                            }
                                        }}
                                    />
                                }
                            />
                        </FormGroup>
                    </Stack>
                </Collapse>
            </Paper>
        </React.Fragment>
    );
}

function TabPanel(props) {
    const {children, value, index} = props;

    return (
        <div hidden={value !== index}>
            {value === index && <Box sx={{mt: 3}}>{children}</Box>}
        </div>
    );
}

export default function Settings() {

    const {i18n} = useTranslation();

    const sdhHourPrice = useSelector(state => state.settings.sdhHourPrice);
    const diffFlag = useSelector(state => state.settings.diffFlag);
    const WorkFlag = useSelector(state => state.settings.editWorkOrder);

    const login = useSelector(state => state.account.login);
    const count = useSelector(state => state.license.count);
    const dateBegin = useSelector(state => state.license.dateBegin);
    const dateEnd = useSelector(state => state.license.dateEnd);
    const daysLeft = useSelector(state => state.license.daysLeft);
    const title = useSelector(state => state.license.title);

    const licenseEnded = useSelector(state => state.license.licenseEnded);
    const licenseEnding = useSelector(state => state.license.licenseEnding);
    const licenseCountEnded = useSelector(state => state.license.licenseCountEnded);
    const licenseDayCountEnded = useSelector(state => state.license.licenseDayCountEnded);

    const selectedMileageType = useSelector(state => state.settings.mileageType);
    const mileageOptions = useSelector(state => state.settings.mileageOptions);
    const selectedMileageTypeOption = mileageOptions.find(opt => opt.value === selectedMileageType);

    const dispatch = useDispatch();

    function handleDiffFlagChange(event) {
        dispatch(changeDiffFlag(event.target.value));
    }

    function handleWorkUpdateFlagChange(event) {
        dispatch(changeUpdateWorkFlag(event.target.checked));
    }

    const [value, setValue] = React.useState(0);
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    return (
        <Container sx={{py: 4}}>
            <Typography variant="h5" gutterBottom>
                Настройки приложения
            </Typography>

            <Tabs
                value={value}
                onChange={handleChange}
                variant="fullWidth"
                textColor="primary"
                indicatorColor="primary"
            >
                <Tab label="Информация"/>
                <Tab label="Лицензия"/>
                <Tab label="Настройки"/>
                <Tab label="Партнерские автосервисы"/>
            </Tabs>


            <TabPanel value={value} index={0}>
                <Card>
                    <CardContent sx={{m: 0, p: 2, pt: 1, backgroundColor: 'rgb(237, 246, 254)'}}>
                        <Typography variant="body1" gutterBottom>
                            Вы можете производить поиск по 2 или более словам, набирая только начальные буквы слов.
                            Например, набрав "охл ж" можно быстро найти Охлаждающую жидкость.
                        </Typography>

                        <Typography variant="body1" gutterBottom>
                            Обратите внимание, что представленные в каталоге нормативы на замену жидкостей (масел)
                            одинаковы для всех автомобилей.
                            Если Вы хотите изменить существующий норматив или создать новый, то Вы можете это сделать
                            самостоятельно,
                            используя универсальный каталог деталей/жидкостей/процедур. Созданные Вами нормативы будут
                            сохранены и будут показываться
                            Вам при каждом входе в эту модель в отдельном разделе "Собственные нормативы", расположенном
                            в нижней части каталога.
                            А при поиске собственный норматив будет помечен спецсимволом
                        </Typography>
                        <Typography variant="body1" gutterBottom>
                            В разделе «Недавно открытые» отображаются заказ-наряды, с которыми вы работали ранее.
                            Карточка содержит краткую информацию об автомобиле и позволяет быстро выполнить нужное
                            действие.
                            Открыть — перейти к просмотру или редактированию(если разрешено редактирование сохранённых
                            заказ-нарядов) текущего заказ-наряда.
                            Копировать — создать новый заказ-наряд на основе существующего (все работы будут
                            перенесены).
                            Создать новый — оформить новый пустой заказ-наряд для данного автомобиля.
                            В карточке отображается:
                            Марка, модель и год выпуска автомобиля
                            Модификация и тип двигателя
                            Пробег если заполнено
                            Госномер если заполнено
                            Vin/Frame если заполнено
                            Количество добавленных работ
                        </Typography>
                        <Typography variant="body1" gutterBottom>
                            Обратите внимание,заполните пробег и госномер и в будущем вы сможете находить такие
                            заказ-наряды. Так можно будет вывести на экран историю ремонтов нужного автомобиля.
                            в разделе "Поиск" на главной
                        </Typography>
                    </CardContent>
                </Card>
            </TabPanel>


            <TabPanel value={value} index={1}>
                <Card>
                    <CardContent>
                        {licenseEnded ?
                            null
                            :
                            <TableContainer component={Paper}>
                                <Table>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell>Логин</TableCell>
                                            <TableCell>{login}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Тип</TableCell>
                                            <TableCell>{title}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Осталось запросов</TableCell>
                                            <TableCell>{count}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Осталось дней</TableCell>
                                            <TableCell>{daysLeft}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Дата активации</TableCell>
                                            <TableCell>{dateBegin ? (new Date(dateBegin)).toLocaleDateString() : 'Нет активной лицензии'}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Дата окончания</TableCell>
                                            <TableCell>{dateEnd ? (new Date(dateEnd)).toLocaleDateString() : 'Нет активной лицензии'}</TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        }
                        {!licenseEnding && !licenseEnded && !licenseCountEnded
                            ? <Alert severity="success" sx={{mt: 1}}>Лицензия активна</Alert>
                            : null
                        }
                        {licenseEnding ? <Alert severity="warning" sx={{mt: 1}}>Лицензия заканчивается</Alert> : null}
                        {licenseEnded ? <Alert severity="error" sx={{mt: 1}}>Нет активной лицензии</Alert> : null}
                        {licenseCountEnded ?
                            <Alert severity="error" sx={{mt: 1}}>Запросы закончились, обратитесь к менеджеру</Alert> :
                            <div/>}
                        {licenseDayCountEnded ?
                            <Alert severity="error" sx={{mt: 1}}>Суточные запросы закончились, обратитесь к
                                менеджеру</Alert> : null}
                        <Stack direction={'row'} alignItems={'center'} sx={{mt: 1}}>

                            <Box sx={{ml: 1}}>
                                <Link href={'../../purchase/tariffs'} underline={'none'} variant={'subtitle1'}>Купить
                                    лицензию</Link>
                            </Box>
                        </Stack>

                    </CardContent>
                </Card>
            </TabPanel>


            <TabPanel value={value} index={2}>
                <Stack spacing={1} justifyContent={"center"} display={"flex"} alignItems={"center"}>

                    <Box sx={{ml: 2, mr: 2, mb: 2, maxWidth: "900px"}}>
                        <Typography variant={'h5'}>Настройки расчётов</Typography>
                        <Paper sx={{width: '100%', p: 1}}>
                            <Stack alignItems='flex-start' spacing={1}>

                                <NumericField
                                    size="small"
                                    label="Стоимость нормо-часа"
                                    value={Number(sdhHourPrice)}
                                    allowNegative={false}
                                    decimalScale={2}
                                    emptyValue={0}
                                    showEmptyValue
                                    fixedDecimalScale
                                    InputProps={{inputProps: {max: 1000000000, autoComplete: 'off'}}}
                                    onValueChange={(value) => dispatch(changeSdhHourPrice(value))}
                                />

                                <Divider sx={{width: '100%'}} orientation='horizontal'/>

                                <FormControl>
                                    <FormLabel id="settings-diff-flag-label">Выберите на какую величину будет влиять
                                        параметр
                                        сложности</FormLabel>
                                    <RadioGroup
                                        aria-labelledby="settings-diff-flag-label"
                                        name="diff-flag-radio-buttons-group"
                                    >
                                        <FormControlLabel control={
                                            <Radio
                                                checked={Number(diffFlag) === 1}
                                                value={1}
                                                onChange={handleDiffFlagChange}
                                            />
                                        }
                                                          label="Стоимость нормо-часа"
                                        />
                                        <FormControlLabel control={
                                            <Radio
                                                checked={Number(diffFlag) === 0}
                                                value={0}
                                                onChange={handleDiffFlagChange}
                                            />
                                        }
                                                          label="Длительность работы"
                                        />
                                    </RadioGroup>
                                </FormControl>

                                <Divider sx={{width: '100%'}} orientation='horizontal'/>

                                <VATSettings title={'НДС за услуги'} vatKey={VATs.jobs}/>
                                <VATSettings title={'НДС за товары'} vatKey={VATs.parts} useOptions/>
                            </Stack>
                        </Paper>
                        <PrintSettings/>
                        <Typography sx={{mt: 1}} variant={'h5'} align='left'>
                            {'Прочие настройки'}
                        </Typography>
                        <FormGroup>
                            <FormControlLabel
                                label="Запретить редактирование старых заказ-нарядов"
                                control={
                                    <Switch
                                        checked={Number(WorkFlag) === 1}
                                        onChange={handleWorkUpdateFlagChange}
                                    />
                                }
                            />
                        </FormGroup>
                        <FormGroup>
                            <Stack sx={{mb: 2}} direction={'row'} justifyContent='start'>
                                <Typography variant="body1" sx={{mt: '2px'}}>Пробег автомобилей по умолчанию
                                    измеряется</Typography>
                                <Box sx={{ml: 1}}>
                                    <Autocomplete
                                        options={mileageOptions}
                                        getOptionLabel={(option) => option.fullLabel[i18n.language]}
                                        value={selectedMileageTypeOption}
                                        onChange={(event, newValue, reason) => {
                                            dispatch(changeMileageType(newValue.value));
                                        }}
                                        disableClearable
                                        size="small"
                                        sx={{width: 190}}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                variant="standard"
                                                size="small"
                                                //sx={{'.MuiInputBase-input': {padding: '2px 4px'}}}
                                            />
                                        )}
                                    />
                                </Box>
                            </Stack>
                        </FormGroup>
                    </Box>

                </Stack>
            </TabPanel>
            <TabPanel value={value} index={3}>
                <Stack spacing={1} justifyContent={"center"} display={"flex"} alignItems={"center"}>
                    <Friends/>
                </Stack>
            </TabPanel>
        </Container>
    );
}
*/

import {
    Box,
    Stack,
    Table,
    Link,
    TableBody,
    TableCell,
    TableContainer,
    TableRow,
    TextField,
    Typography,
    FormGroup,
    FormControlLabel,
    Switch,
    FormControl,
    FormLabel,
    RadioGroup,
    Radio,
    Alert,
    IconButton, Button, DialogTitle, DialogContent, DialogContentText, DialogActions, Dialog, Fab, Tooltip, Collapse,
    Divider,
    Grid,
    Chip,
    CircularProgress, Autocomplete, List,
} from "@mui/material";
import Paper from "@mui/material/Paper";
import {useDispatch, useSelector} from "react-redux";

import {
    changeDiffFlag,
    changeSdhHourPrice, changeShowCarTable, changeShowClientTable,
    changeShowComplexity,
    changeShowCompanyInfo,
    changeShowLogoOnLeft,
    changeOrganization,
    changeCompanyName,
    changeCompanyTin,
    changeCompanyAddress,
    changeCompanyPhoneNumber,
    changeCompanyLogoObjectUrl,
    changeShowFromAccount,
    VATs,
    changeVAT,
    pushVATOption,
    popVATOption,
    MaxVATOptionsCount,
    changeUpdateWorkFlag,
    changeMileageType
} from "../redux/settingsSlice";
import BookIcon from "@mui/icons-material/BookOutlined";
import {Form, Formik} from "formik";
import InfoIcon from "@mui/icons-material/InfoOutlined";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/DeleteOutline"
import CloseIcon from "@mui/icons-material/Close"
import SaveIcon from "@mui/icons-material/Save"
import DoneAllIcon from "@mui/icons-material/DoneAll"
import AccessTimeIcon from "@mui/icons-material/AccessTime"
import React, {useEffect, useState, useCallback} from "react";
import {
    addFriend,
    confirmFriend,
    deleteFriend,
    getFriendRequests,
    getFriends,
    getPendingFriends,

    setShowCompanyInfo,
    setShowFromAccount,
    setShowLogoOnLeft,
    setOrganization,
    setCompanyName,
    setCompanyTin,
    setCompanyAdress,
    setCompanyPhoneNumber,
    setCompanyLogo,
    getOrganization,
    getCompanyTin,
    loadPrintSettings,
    deletePendingFriend,
} from "../serverREST";
import {ImageInput} from './settingsParts/ImageInput.js'
import debounce from "../utils/debounce.js";
import {sumWithVAT, vatString, vatFromSum} from "./calculatorParts/TableSums.js";
import {Cancel, HelpOutline} from "@mui/icons-material";
import {NumericField} from "./calculatorParts/NumberField.js";
import {useTranslation} from 'react-i18next';

const TooltipText = 'Впишите email ваших партнеров (учетных записей в MotorData Нормы времени) для совместного использования всех созданных членами группы собственных работ. Этот функционал, учитывая существующее разнообразие марок и моделей, может значительно облегчить вашу работу. При этом Вы будете видеть базовый норматив системы, при наличии, "собственный норматив" и варианты норматива ваших партнеров с привязкой к уникальному идентификатору партнера. Поэтому, даже если в группе будет несколько автосервисов, вы сможете выбрать наиболее приемлемый для вас вариант.';


function AddFriendFrom({setOpenAddFriend, onSave, onError}) {
    const friends = useSelector(state => state.friends.friends);
    const pendingFriends = useSelector(state => state.friends.pendingFriends);
    const userEmail = useSelector(state => state.account.login);

    const existsEmails = new Set([
        ...friends.map(f => f.login),
        ...pendingFriends.map(f => f.login),
    ]);

    return (

        <Formik
            initialValues={{
                friendEmail: '',
            }}

            onSubmit={
                (values) => {
                    setOpenAddFriend(false);

                    const email = values.friendEmail ? values.friendEmail.trim() : null;

                    if (email && email !== userEmail) {
                        if (existsEmails.has(email)) {
                            onError && onError(409); // 409 Conflict
                        } else {
                            addFriend(email, (isAdded, status) => {
                                isAdded ? (onSave && onSave()) : (onError && onError(status));
                            });
                        }
                    }
                }
            }>
            {({setFieldValue, values}) => (
                <Form>
                    <Stack sx={{mt: 1}} direction={'row'} justifyContent='space-between'>
                        <TextField
                            size={'small'}
                            autoFocus={true}
                            value={values.friendEmail}
                            sx={{mr: 1, flexGrow: 1}}
                            label={'Email партнёра'}
                            onChange={
                                (event) => {
                                    setFieldValue('friendEmail', event.target.value)
                                }}
                        >
                        </TextField>

                        <IconButton
                            size="medium"
                            color="secondary"
                            aria-label="menu"
                            onClick={() => {
                                setOpenAddFriend(false)
                            }}
                        >
                            <CloseIcon/>
                        </IconButton>

                        <IconButton
                            size="medium"
                            color="secondary"
                            aria-label="menu"
                            type={'submit'}
                        >
                            <SaveIcon/>
                        </IconButton>
                    </Stack>

                </Form>
            )}
        </Formik>

    );
}

function FriendRequestDialog({username}) {
    const [open, setOpen] = useState(true);
    const [wait, setWait] = useState(false);
    const [hasError, setHasError] = useState(false);

    const handleConfirm = () => {
        setWait(true);
        confirmFriend(username, 'accept', (accepted) => {
            setWait(false);
            accepted ? setOpen(false) : setHasError(true);
        });
    };

    const handleDecline = () => {
        confirmFriend(username, 'decline');
        setOpen(false);
    };

    const fadeInAnim = {
        opacity: 0,
        animation: 'fadeIn 0.5s ease-in-out 1s forwards',
        '@keyframes fadeIn': {
            '0%': {opacity: 0},
            '100%': {opacity: 1},
        },
    };

    return (
        <Dialog
            open={open}
            onClose={() => setOpen(false)}
        >
            <DialogTitle>
                Запрос дружбы
            </DialogTitle>
            <DialogContent>
                {!hasError
                    ?
                    <DialogContentText>
                        Вам поступил запрос в друзья от пользователя <b>{username}</b>. Желаете подтвердить запрос или
                        отклонить?
                        Подтвердив запрос, вы объедините выдачу собственных работ с дружественным автосервисом.
                    </DialogContentText>
                    :
                    <DialogContentText>Приглашение не найдено</DialogContentText>
                }
            </DialogContent>
            {!hasError
                ?
                <DialogActions>
                    {wait && <CircularProgress sx={{mr: 1, ...fadeInAnim}} size={24}/>}
                    <Button onClick={handleConfirm} disabled={wait}>
                        Подтвердить
                    </Button>
                    <Button onClick={handleDecline} disabled={wait}>
                        Отклонить
                    </Button>
                </DialogActions>
                :
                <DialogActions>
                    <Button onClick={() => setOpen(false)}>
                        Закрыть
                    </Button>
                </DialogActions>
            }

        </Dialog>
    );
}

function FriendEntry(props) {
    const {email, accepted, user_code, user_num, lodader} = props;
    const isAccepted = Boolean(accepted);

    const AcceptedFriendTooltip = () => (
        <Tooltip title='Автосервис подтвердил Вашу заявку и объединил с Вами выдачу своих работ' arrow>
            <DoneAllIcon color="success"/>
        </Tooltip>
    );
    const WaitedFriendTooltip = () => (
        <Tooltip title='Автосервис пока не подтвердил Вашу заявку' arrow>
            <AccessTimeIcon color="warning"/>
        </Tooltip>
    );

    return (
        <Stack sx={{justifyContent: 'start'}} direction={'row'} alignItems={'center'}>
            <Stack direction={'row'} alignItems={'center'}>
                {isAccepted ? <Box style={{
                        "display": "flex",
                        "gap": "4px",

                    }}>
                        <AcceptedFriendTooltip/>
                        <Box style={{
                            "padding": "0px 2px",
                            "backgroundColor": `#${user_code}`,
                            "color": "white",
                            "alignItems": "center",
                            "display": "flex",
                            "borderRadius": "2px"
                        }}>
                            <Typography variant='body2' fontSize={13}>
                                {user_num}
                            </Typography>
                        </Box>
                    </Box>
                    : <WaitedFriendTooltip/>}
                <Stack width={"315px"}>
                    <Tooltip title={email} arrow>
                        <Typography sx={{
                            m: 1,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            maxWidth: "88%"
                        }}> {email} </Typography>
                    </Tooltip>
                </Stack>
                <Tooltip title={"Удалить"} arrow>
                    <IconButton
                        size="medium"
                        color="secondary"
                        aria-label="menu"
                        sx={{position: "absolute", right: "5px"}}
                        onClick={() => isAccepted ? deleteFriend(email, lodader) : deletePendingFriend(email, lodader)}
                    >
                        <DeleteIcon/>
                    </IconButton>
                </Tooltip>
            </Stack>

        </Stack>
    );
}

function TimeoutAlert({open, setOpen, severity, text, duration}) {
    const _duration = duration ? duration : 3000;

    useEffect(() => {
        if (open) {
            const timeout = setTimeout(() => setOpen(false), _duration);
            return () => clearTimeout(timeout);
        }
    }, [open]);

    return (
        <Collapse in={open} unmountOnExit>
            <Alert
                severity={severity}
                onClose={() => setOpen(false)}
                sx={{mt: 1}}
            >
                {text}
            </Alert>
        </Collapse>
    );
};

function Friends() {
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        getFriends(setLoading)
        getFriendRequests()
        getPendingFriends(setLoading)
    }, [])
    /* useEffect(() => {
         const loadData = async () => {
             setLoading(true);

             try {
                 await Promise.all([
                     getFriends(),
                     getFriendRequests(),
                     getPendingFriends(),
                 ]);
             } catch (error) {
                 console.log('Friends loading error:', error);
             } finally {
                 setLoading(false);
             }
         };

         loadData();
     }, []);*/

    const [openAddFriend, setOpenAddFriend] = useState(false);
    const [addFriendAlert, setAddFriendAlert] = useState(false);
    const [onConflictAlert, setOnConflictAlert] = useState(false);

    const friends = useSelector(state => state.friends.friends);
    const pendingFriends = useSelector(state => state.friends.pendingFriends);
    const friendRequests = useSelector(state => state.friends.friendRequests);
    const licenseEnded = useSelector(state => state.license.licenseEnded);
    const licenseCountEnded = useSelector(state => state.license.licenseCountEnded);
    const licenseDayCountEnded = useSelector(state => state.license.licenseDayCountEnded);

    const canAddFriends = !licenseEnded && !licenseCountEnded && !licenseDayCountEnded;

    return (
        <Box sx={{ml: 2, maxWidth: '370px'}}>
            <Typography variant={'h5'}>Партнерские автосервисы</Typography>
            <Typography
                sx={{mt: 0, p: 2, backgroundColor: 'rgb(237, 246, 254)'}}
                textAlign='justify'
                variant='body1'
            >
                <IconButton
                    disableRipple
                    size={'small'}
                    sx={{pb: 0, pt: 0, color: 'rgb(77, 171, 245)', cursor: 'default'}}>
                    <InfoIcon fontSize={'small'}/>
                </IconButton>
                {TooltipText}
            </Typography>

            <Paper sx={{width: '100%', mt: 1}}>
                <Box sx={{p: 1}}>
                    <Stack //justifyContent={"start"}
                        alignItems={"start"}
                        position={"relative"} minHeight={"10px"}>
                        {loading ?
                            <Box
                                sx={{
                                    position: 'absolute',
                                    inset: 0,
                                    zIndex: 2,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    bgcolor: 'rgba(255, 255, 255, 0.65)',
                                    borderRadius: 1,
                                }}
                            >
                                <CircularProgress size={36}/>
                            </Box>
                            : null}
                        <List
                            sx={{
                                maxHeight: 400,
                                overflowY: 'auto',
                                width: '100%'
                            }}>
                            {friends.map((friend, index) =>
                                <FriendEntry
                                    key={index}
                                    email={friend.login}
                                    user_code={friend.user_code}
                                    user_num={friend.user_num}
                                    lodader={setLoading}
                                    accepted
                                />
                            )}
                            {pendingFriends.map((friend, index) =>
                                <FriendEntry
                                    key={index}
                                    lodader={setLoading}
                                    email={friend.login}
                                />
                            )}
                        </List>
                        {!licenseEnded &&
                            friendRequests.map((friend, index) => {
                                return (
                                    <FriendRequestDialog key={index} username={friend.login}/>
                                )
                            })
                        }
                    </Stack>
                    <Button
                        sx={{width: '100%'}}
                        variant={'outlined'}
                        startIcon={<AddIcon/>}
                        disabled={!canAddFriends || loading}
                        onClick={() => setOpenAddFriend(true)}
                    >
                        {'Добавить партнёра'}
                    </Button>
                    {!canAddFriends &&
                        <Stack spacing={1}>
                            <Alert sx={{mt: 1, pl: 1}} severity="warning">
                                {'Добавить партнёра можно только при наличии активной лицензии'}
                            </Alert>
                            <Link sx={{ml: 1}} href={'../../purchase/tariffs'} underline={'none'} variant={'subtitle1'}>Купить
                                лицензию</Link>
                        </Stack>
                    }
                    <Collapse in={openAddFriend} unmountOnExit>
                        <AddFriendFrom
                            setOpenAddFriend={setOpenAddFriend}
                            onSave={() => setAddFriendAlert(true)}
                            onError={(status) => {
                                (status === 409) && setOnConflictAlert(true);
                            }}
                        />
                    </Collapse>
                    <TimeoutAlert
                        open={addFriendAlert}
                        setOpen={setAddFriendAlert}
                        duration={5000}
                        severity='success'
                        text={'Если пользователь с указанным email существует, он сможет принять приглашение.'}
                    />
                    <TimeoutAlert
                        open={onConflictAlert}
                        setOpen={setOnConflictAlert}
                        duration={5000}
                        severity='error'
                        text={'Пользователь с указанным email уже является партнёром или приглашение уже отправлено. Обновите страницу.'}
                    />
                </Box>
            </Paper>

            <Typography sx={{m: 0, mt: 2}} variant={'h5'}>Информация</Typography>

            <Box sx={{m: 0, p: 2, pt: 1, backgroundColor: 'rgb(237, 246, 254)'}}>
                <Typography variant={'body1'} sx={{mt: 1}}>
                    <IconButton
                        disableRipple
                        size={'small'}
                        sx={{pb: 0, pt: 0, color: 'rgb(77, 171, 245)', cursor: 'default'}}
                    >
                        <InfoIcon fontSize={'small'}/>
                    </IconButton>
                    {
                        `Вы можете производить поиск по 2 или более словам, набирая только начальные буквы слов.
                         Например, набрав "охл ж" можно быстро найти Охлаждающую жидкость.`
                    }
                </Typography>
                <Typography variant={'body1'} sx={{mt: 1}}>
                    Обратите внимание, что представленные в каталоге нормативы на замену жидкостей (масел)
                    <strong> одинаковы для всех автомобилей</strong>. Если Вы хотите изменить существующий норматив или
                    создать новый, то Вы можете это сделать самостоятельно,
                    используя универсальный каталог деталей/жидкостей/процедур. Созданные Вами нормативы будут
                    сохранены и будут показываться Вам при каждом входе в эту модель в отдельном разделе
                    "Собственные нормативы", расположенном в нижней части каталога.
                    А при поиске собственный норматив будет помечен спецсимволом
                    <IconButton size={'small'} color={'secondary'}>
                        <BookIcon fontSize={'small'}/>
                    </IconButton>
                </Typography>
            </Box>
        </Box>
    )
}

export default function Settings() {
    const {i18n} = useTranslation();
    const currentLang = i18n.language.split('-')[0];

    const sdhHourPrice = useSelector(state => state.settings.sdhHourPrice);
    const diffFlag = useSelector(state => state.settings.diffFlag);
    const WorkFlag = useSelector(state => state.settings.editWorkOrder);

    const login = useSelector(state => state.account.login);
    const count = useSelector(state => state.license.count);
    const dateBegin = useSelector(state => state.license.dateBegin);
    const dateEnd = useSelector(state => state.license.dateEnd);
    const daysLeft = useSelector(state => state.license.daysLeft);
    const title = useSelector(state => state.license.title);

    const licenseEnded = useSelector(state => state.license.licenseEnded);
    const licenseEnding = useSelector(state => state.license.licenseEnding);
    const licenseCountEnded = useSelector(state => state.license.licenseCountEnded);
    const licenseDayCountEnded = useSelector(state => state.license.licenseDayCountEnded);

    const selectedMileageType = useSelector(state => state.settings.mileageType);
    const mileageOptions = useSelector(state => state.settings.mileageOptions);
    const selectedMileageTypeOption = mileageOptions.find(opt => opt.value === selectedMileageType);

    const dispatch = useDispatch();

    function handleDiffFlagChange(event) {
        dispatch(changeDiffFlag(event.target.value));
    }

    function handleWorkUpdateFlagChange(event) {
        dispatch(changeUpdateWorkFlag(event.target.checked));
    }

    return (
        <Box sx={{p: 1}}>
            <Stack direction={'row'}>
                <Box sx={{ml: 2}}>
                    <Typography variant={'h5'}>Лицензия</Typography>
                    <Paper sx={{maxWidth: '400px', p: 1}}>
                        {licenseEnded ?
                            <div/>
                            :
                            <TableContainer component={Paper} sx={{maxWidth: 1200}}>
                                <Table>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell>Логин</TableCell>
                                            <TableCell>{login}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Тип</TableCell>
                                            <TableCell>{title}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Осталось запросов</TableCell>
                                            <TableCell>{count}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Осталось дней</TableCell>
                                            <TableCell>{daysLeft}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Дата активации</TableCell>
                                            <TableCell>{dateBegin ? (new Date(dateBegin)).toLocaleDateString() : 'Нет активной лицензии'}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Дата окончания</TableCell>
                                            <TableCell>{dateEnd ? (new Date(dateEnd)).toLocaleDateString() : 'Нет активной лицензии'}</TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        }
                        {!licenseEnding && !licenseEnded && !licenseCountEnded
                            ? <Alert severity="success" sx={{mt: 1}}>Лицензия активна</Alert>
                            : <div/>
                        }
                        {licenseEnding ? <Alert severity="warning" sx={{mt: 1}}>Лицензия заканчивается</Alert> : <div/>}
                        {licenseEnded ? <Alert severity="error" sx={{mt: 1}}>Нет активной лицензии</Alert> : <div/>}
                        {licenseCountEnded ?
                            <Alert severity="error" sx={{mt: 1}}>Запросы закончились, обратитесь к менеджеру</Alert> :
                            <div/>}
                        {licenseDayCountEnded ?
                            <Alert severity="error" sx={{mt: 1}}>Суточные запросы закончились, обратитесь к
                                менеджеру</Alert> : <div/>}
                        <Stack direction={'row'} alignItems={'center'} sx={{mt: 1}}>

                            <Box sx={{ml: 1}}>
                                <Link href={'../../purchase/tariffs'} underline={'none'} variant={'subtitle1'}>Купить
                                    лицензию</Link>
                            </Box>
                        </Stack>
                    </Paper>
                </Box>
                <Box sx={{ml: 2, mr: 2, mb: 2}}>
                    <Typography variant={'h5'}>Настройки расчётов</Typography>
                    <Paper sx={{width: '100%', p: 1}}>
                        <Stack alignItems='flex-start' spacing={1}>

                            <NumericField
                                size="small"
                                label="Стоимость нормо-часа"
                                value={Number(sdhHourPrice)}
                                allowNegative={false}
                                decimalScale={2}
                                emptyValue={0}
                                showEmptyValue
                                fixedDecimalScale
                                InputProps={{inputProps: {max: 1000000000, autoComplete: 'off'}}}
                                onValueChange={(value) => dispatch(changeSdhHourPrice(value))}
                            />

                            <Divider sx={{width: '100%'}} orientation='horizontal'/>

                            <FormControl>
                                <FormLabel id="settings-diff-flag-label">Выберите на какую величину будет влиять
                                    параметр
                                    сложности</FormLabel>
                                <RadioGroup
                                    aria-labelledby="settings-diff-flag-label"
                                    name="diff-flag-radio-buttons-group"
                                >
                                    <FormControlLabel control={
                                        <Radio
                                            checked={Number(diffFlag) === 1}
                                            value={1}
                                            onChange={handleDiffFlagChange}
                                        />
                                    }
                                                      label="Стоимость нормо-часа"
                                    />
                                    <FormControlLabel control={
                                        <Radio
                                            checked={Number(diffFlag) === 0}
                                            value={0}
                                            onChange={handleDiffFlagChange}
                                        />
                                    }
                                                      label="Длительность работы"
                                    />
                                </RadioGroup>
                            </FormControl>

                            <Divider sx={{width: '100%'}} orientation='horizontal'/>

                            <VATSettings title={'НДС за услуги'} vatKey={VATs.jobs}/>
                            <VATSettings title={'НДС за товары'} vatKey={VATs.parts} useOptions/>
                        </Stack>
                    </Paper>
                    <PrintSettings/>
                    <Typography sx={{mt: 1}} variant={'h5'} align='left'>
                        {'Прочие настройки'}
                    </Typography>
                    <FormGroup>
                        <FormControlLabel
                            label="Разрешить редактирование сохранённых заказ-нарядов"
                            control={
                                <Switch
                                    checked={Number(WorkFlag) === 1}
                                    onChange={handleWorkUpdateFlagChange}
                                />
                            }
                        />
                    </FormGroup>
                    <FormGroup>
                        <Stack sx={{mb: 2}} direction={'row'} justifyContent='start'>
                            <Typography variant="body1" sx={{mt: '2px'}}>Пробег автомобилей по умолчанию
                                измеряется</Typography>
                            <Box sx={{ml: 1}}>
                                <Autocomplete
                                    options={mileageOptions}
                                    getOptionLabel={(option) => option.fullLabel[currentLang]}
                                    value={selectedMileageTypeOption}
                                    onChange={(event, newValue, reason) => {
                                        dispatch(changeMileageType(newValue.value));
                                    }}
                                    disableClearable
                                    size="small"
                                    sx={{width: 190}}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            variant="standard"
                                            size="small"
                                            //sx={{'.MuiInputBase-input': {padding: '2px 4px'}}}
                                        />
                                    )}
                                />
                            </Box>
                        </Stack>
                    </FormGroup>
                </Box>
                <Friends/>

            </Stack>
        </Box>
    );
}

const VATSettings = ({title, vatKey, useOptions}) => {
    const vat = useSelector(state => state.settings.vats[vatKey]);
    const canAddOptions = Boolean(useOptions);

    const dispatch = useDispatch();

    return (
        <FormControl>
            <FormControlLabel
                label={title}
                control={
                    <Switch
                        checked={vat.active}
                        onChange={(event) => {
                            dispatch(changeVAT({key: vatKey, active: event.target.checked}));
                        }}
                    />
                }
            />
            <Collapse in={vat.active} unmountOnExit sx={{ml: 2, pt: 2}}>
                <Formik
                    initialValues={{value: vat.value}}
                    onSubmit={(values) => {
                        const value = Number(Number(values.value).toFixed(2));

                        if (value !== vat.value) {
                            dispatch(changeVAT({key: vatKey, value: value}));
                        }
                    }}
                >
                    {({setFieldValue, values, handleSubmit}) => (
                        <Form onSubmit={handleSubmit}>
                            <VATNumberField
                                label={canAddOptions ? 'Значение НДС по умолчанию (%)' : "Значение НДС (%)"}
                                value={values.value}
                                onValueChange={(value) => setFieldValue('value', value)}
                                onBlur={handleSubmit}
                            />
                        </Form>
                    )}
                </Formik>
                {canAddOptions &&
                    <VATOptions vatKey={vatKey} vat={vat}/>
                }
                <VATTypeSetings vatKey={vatKey}/>
            </Collapse>
        </FormControl>
    );
};


const VATOptions = ({vatKey, vat}) => {
    const [open, setOpen] = useState(false);

    const dispatch = useDispatch();

    const hasOptions = vat.options.length > 0;
    const canAddOption = vat.options.length < MaxVATOptionsCount;
    const options = [...vat.options].sort((a, b) => a - b);

    return (
        <Box>
            {hasOptions &&
                <Stack direction='row' flexWrap='wrap' sx={{mt: 1, maxWidth: 450}}>
                    {options.map((option) => (
                        <Chip
                            variant='outlined'
                            sx={{
                                m: '2px', ml: 0, mr: '4px',
                                borderRadius: 1,
                            }}
                            key={option}
                            label={
                                <Typography>{`${option}%`}</Typography>
                            }
                            onDelete={() => {
                                dispatch(popVATOption({
                                    key: vatKey,
                                    option: Number(option),
                                }))
                            }}
                            deleteIcon={<Cancel/>}
                        />
                    ))}
                </Stack>
            }
            {open
                ?
                <Formik
                    initialValues={{
                        value: null,
                    }}
                    onSubmit={(values) => {
                        setOpen(false);

                        if (values.value !== null) {
                            dispatch(pushVATOption({
                                key: vatKey,
                                option: Number(values.value),
                            }))
                        }
                    }}
                >
                    {({setFieldValue, values, handleSubmit}) => (
                        <Form>
                            <Stack sx={{mt: 1}} direction='row'>
                                <VATNumberField
                                    id='custom-vat-input'
                                    value={values.value}
                                    emptyValue={null}
                                    showEmptyValue={false}
                                    onValueChange={(value) => setFieldValue('value', value)}
                                    onBlur={() => setOpen(false)}
                                />
                                <IconButton
                                    size="medium"
                                    color="secondary"
                                    type="submit"
                                    onMouseDown={(e) => {
                                        e.preventDefault();
                                        handleSubmit();
                                    }}
                                >
                                    <SaveIcon/>
                                </IconButton>
                            </Stack>
                        </Form>
                    )}
                </Formik>
                :
                <Box style={{display: "flex", gap: "10px", alignItems: "center"}}>
                    <Button
                        sx={{
                            mt: 1,
                        }}
                        disabled={!canAddOption}
                        variant={'outlined'}
                        startIcon={<AddIcon/>}
                        onClick={() => {
                            setOpen(true);
                            setTimeout(() => document.getElementById('custom-vat-input')?.focus(), 10);
                        }}
                    >
                        {'Добавить значение'}
                    </Button>
                    <Tooltip
                        style={{marginTop: "8px"}}
                        title={'Значение будет доступно для выбора при добавлении детали в заказ-наряд '}
                        arrow
                        placement="right"
                        componentsProps={{
                            tooltip: {sx: {fontSize: "16px"}},
                        }}
                    >
                        <HelpOutline fontSize={'small'} sx={{color: 'gray'}}/>
                    </Tooltip>
                </Box>
            }
        </Box>
    );
};

const VATTypeSetings = ({vatKey}) => {
    const vat = useSelector(state => state.settings.vats[vatKey]);
    return (
        <React.Fragment>
            <RadioGroup>
                <VATRadioControll text={'НДС в сумме'} vatKey={vatKey} vat={vat} value={0}/>
                <VATRadioControll text={'НДС сверху'} vatKey={vatKey} vat={vat} value={1}/>
            </RadioGroup>
        </React.Fragment>
    );
};

const VATRadioControll = ({text, vatKey, vat, value}) => {
    const dispatch = useDispatch();

    const handleTypeChange = (event) => {
        const newType = Number(event.target.value);

        dispatch(changeVAT({key: vatKey, type: newType}));
    };

    return (
        <FormControlLabel
            control={
                <Radio
                    checked={vat.type === value}
                    value={value}
                    onChange={handleTypeChange}
                />
            }
            label={
                <Stack direction='row' spacing={1}>
                    <Typography>{text}</Typography>
                    <VATExampleTooltip vatType={value}/>
                </Stack>
            }
        />
    );
};

const VATExampleTooltip = ({vatType}) => {
    return (
        <Tooltip
            title={<VATExample vatType={vatType}/>}
            arrow
            placement="right"
            componentsProps={{
                tooltip: {sx: {borderRadius: 3}},
            }}
        >
            <HelpOutline fontSize={'small'} sx={{color: 'gray'}}/>
        </Tooltip>
    );
};

const VATExample = ({vatType}) => {
    const xs1 = 7;
    const sum = 10000;
    const vat = {active: true, type: vatType, value: 20};

    const data = [
        {title: 'Сумма', value: sum},
        {title: `НДС ${vatString(vat)}`, value: vatFromSum(sum, vat)},
        vatType === 0
            ? {title: 'Сумма без НДС', value: sumWithVAT(sum, vat) - vatFromSum(sum, vat)}
            : {title: 'Сумма с НДС', value: sumWithVAT(sum, vat)},
    ];

    return (
        <Grid container sx={{width: 250}}>
            <Grid item xs={12}>
                <Typography>
                    {vatType === 0
                        ? 'НДС будет выделен из суммы.'
                        : 'НДС будет начислен к сумме.'
                    }
                </Typography>
                <Typography> {'Пример:'} </Typography>
            </Grid>
            {data.map((item, index) => (
                <React.Fragment key={index}>
                    <Grid item xs={xs1}>
                        <Typography> {item.title} </Typography>
                    </Grid>
                    <Grid item xs={12 - xs1}>
                        <Typography> {item.value} </Typography>
                    </Grid>
                </React.Fragment>
            ))}
        </Grid>
    );
};

function VATNumberField(props) {
    return (
        <NumericField
            emptyValue={0}
            showEmptyValue
            {...props}
            size="small"
            InputProps={{inputProps: {min: 0, max: 100, step: 'any', autoComplete: 'off'}}}
            allowNegative={false}
            decimalScale={2}
            onValueChange={(value) => {
                props.onValueChange && props.onValueChange(value);
            }}
        />
    );
}

function PrintSettings({}) {
    const hasPrintSettings = useSelector(state => state.settings.hasPrintSettings);

    const showComplexity = useSelector(state => state.settings.showComplexity);
    const showCarTable = useSelector(state => state.settings.showCarTable);
    const showClientTable = useSelector(state => state.settings.showClientTable);

    const showCompanyInfo = useSelector(state => state.settings.showCompanyInfo);
    const showFromAccount = useSelector(state => state.settings.showFromAccount);
    const showLogoOnLeft = useSelector(state => state.settings.showLogoOnLeft);
    const companyPhoneNumber = useSelector(state => state.settings.companyPhoneNumber);
    const organization = useSelector(state => state.settings.organization);
    const companyName = useSelector(state => state.settings.companyName);
    const companyTin = useSelector(state => state.settings.companyTin);
    const companyAddress = useSelector(state => state.settings.companyAddress);
    const companyLogoObjectUrl = useSelector(state => state.settings.companyLogoObjectUrl);

    const phonePattern = "/^\+?[0-9()\- ]*";
    const phoneRegex = /^\+?[0-9()\- ]*$/;

    const dispatch = useDispatch();

    const updatePrintSettings = () => {
        if (!hasPrintSettings) {
            loadPrintSettings();
        }
    };

    useEffect(() => {
        updatePrintSettings();
    }, []);

    const debounceSendPhone = useCallback(
        debounce((value) => setCompanyPhoneNumber(value), 1000),
        [],
    );
    const debounceSendName = useCallback(
        debounce((value) => setCompanyName(value), 1000),
        [],
    );
    const debounceSendTin = useCallback(
        debounce((value) => setCompanyTin(value), 1000),
        [],
    );
    const debounceSendAdress = useCallback(
        debounce((value) => setCompanyAdress(value), 1000),
        [],
    );
    const debounceSendOrganization = useCallback(
        debounce((value) => setOrganization(value), 1000),
        [],
    );

    return (
        <React.Fragment>
            <Typography sx={{mt: 1}} variant={'h5'} align='left'>
                {'Настройки печати'}
            </Typography>
            <Paper sx={{width: '100%', p: 1}}>
                <FormGroup>
                    <FormControlLabel
                        label="Показать коэф. сложности"
                        control={
                            <Switch
                                checked={showComplexity}
                                onChange={(e) => dispatch(changeShowComplexity(e.target.checked))}
                            />
                        }
                    />
                </FormGroup>
                <FormGroup>
                    <FormControlLabel
                        label="Показать таблицу доп. данных об автомобиле"
                        control={
                            <Switch
                                checked={showCarTable}
                                onChange={(e) => dispatch(changeShowCarTable(e.target.checked))}
                            />
                        }
                    />
                </FormGroup>
                <FormGroup>
                    <FormControlLabel
                        label="Показать таблицу данных клиента"
                        control={
                            <Switch
                                checked={showClientTable}
                                onChange={(e) => dispatch(changeShowClientTable(e.target.checked))}
                            />
                        }
                    />
                </FormGroup>
                <FormGroup>
                    <FormControlLabel
                        label="Показать данные автосервиса"
                        control={
                            <Switch
                                checked={showCompanyInfo}
                                onChange={(e) => {
                                    if (e && e.target && e.target.checked !== undefined) {
                                        dispatch(changeShowCompanyInfo(e.target.checked));
                                        setShowCompanyInfo(e.target.checked).then(() => {
                                            updatePrintSettings();
                                        });
                                    }
                                }}
                            />
                        }
                    />
                </FormGroup>
                <Collapse in={showCompanyInfo}>
                    <Stack
                        direction='column'
                        sx={{m: 2}}
                        spacing={{xs: 1}}
                    >
                        <FormGroup>
                            <FormControlLabel
                                label="Заполнить из личного кабинета"
                                control={
                                    <Switch
                                        checked={showFromAccount}
                                        onChange={(e) => {
                                            const value = e.target.checked;

                                            dispatch(changeShowFromAccount(value));
                                            setShowFromAccount(value);

                                            getOrganization(value);
                                            getCompanyTin(value);
                                        }}
                                    />
                                }
                            />
                        </FormGroup>
                        <TextField
                            size="small"
                            label='Организация'
                            value={organization}
                            disabled={showFromAccount}
                            onChange={(e) => {
                                dispatch(changeOrganization(e.target.value));
                                debounceSendOrganization(e.target.value);
                            }}
                        />
                        <TextField
                            size="small"
                            label='Название автосервиса'
                            value={companyName}
                            onChange={(e) => {
                                dispatch(changeCompanyName(e.target.value));
                                debounceSendName(e.target.value);
                            }}
                        />
                        <TextField
                            size="small"
                            label='ИНН'
                            inputProps={{maxLength: 12}}
                            value={companyTin}
                            disabled={showFromAccount}
                            onChange={(e) => {
                                const value = e.target.value;
                                const filtered = value.replace(/[^0-9]/g, '');

                                dispatch(changeCompanyTin(filtered));
                                debounceSendTin(filtered);
                            }}
                        />
                        <TextField
                            size="small"
                            label='Адрес'
                            value={companyAddress}
                            onChange={(e) => {
                                dispatch(changeCompanyAddress(e.target.value));
                                debounceSendAdress(e.target.value);
                            }}
                        />
                        <TextField
                            size='small'
                            label='Телефон автосервиса'
                            inputProps={{pattern: phonePattern, maxLength: 25}}
                            value={companyPhoneNumber}
                            onChange={(event) => {
                                const value = event.target.value;
                                if (phoneRegex.test(value)) {
                                    dispatch(changeCompanyPhoneNumber(value));
                                    debounceSendPhone(value);
                                }
                            }}
                        />
                        <ImageInput
                            valueObjectURL={companyLogoObjectUrl}
                            allowedTypes='image/png'
                            maxSizeMb={1}
                            onChangeFile={(file) => {
                                if (file) {
                                    dispatch(changeCompanyLogoObjectUrl(URL.createObjectURL(file)));
                                    setCompanyLogo(file);
                                } else {
                                    dispatch(changeCompanyLogoObjectUrl(null));
                                    setCompanyLogo(null);
                                }
                            }}
                        />
                        <FormGroup>
                            <FormControlLabel
                                label="Расположить логотип с левого края страницы"
                                control={
                                    <Switch
                                        checked={showLogoOnLeft}
                                        onChange={(e) => {
                                            if (e && e.target && e.target.checked !== undefined) {
                                                dispatch(changeShowLogoOnLeft(e.target.checked))
                                                setShowLogoOnLeft(e.target.checked);
                                            }
                                        }}
                                    />
                                }
                            />
                        </FormGroup>
                    </Stack>
                </Collapse>
            </Paper>
        </React.Fragment>
    );
}

// NOTE: Какой-то старый закомментированный код по управлению сотрудниками. 
//
// function DeleteDialog({openDeleteFriend, setOpenDeleteFriend, friend}) {
//     return (
//         <Dialog
//             open={openDeleteFriend}
//         >
//             <DialogTitle>
//                 Удаление сотрудника
//             </DialogTitle>
//             <DialogContent>
//                 <DialogContentText>
//                     Вы уверены, что хотите удалить аккаунт сотрудника {friend}?
//                 </DialogContentText>
//             </DialogContent>
//             <DialogActions>
//                 <Button onClick={() => {
//                     deleteEmployee(friend)
//                     setOpenDeleteFriend(false)
//                 }}>
//                     Да
//                 </Button>
//                 <Button onClick={() => {setOpenDeleteFriend(false)}}>
//                     Нет
//                 </Button>
//             </DialogActions>
//         </Dialog>
//     )
// }
//

// function AddDialog({openAddFriend, setOpenAddFriend}) {
//     // const [email, setEmail] = useState('');
//     // const [password, setPassword] = useState('');
//     const validationSchema = Yup.object({
//         email: Yup.string().email().required(),
//         password: Yup.string().required(),
//     });
//
//     return (
//         <Dialog
//             open={openAddFriend}
//             // onClose={handleAddEmployee}
//         >
//             <Formik initialValues={
//                 {
//                     email: '',
//                     password: ''
//                 }
//             }
//                 // validate={(values) => {
//                 //     // console.log(values)
//                 // }}
//                 validationSchema={validationSchema}
//                 // validator={() => ({})}
//                 onSubmit={(values) => {
//                     registerEmployee(values.email, values.password)
//                     setOpenAddFriend(false)
//                 }}>
//                 {({setFieldValue, values}) => (
//                     <Form>
//
//                         <DialogTitle>
//                             Добавление сотрудников
//                         </DialogTitle>
//                         <DialogContent>
//                             <DialogContentText>
//                                 Укажите электронную почту сотрудника и придумайте ему пароль для доступа к аккаунту.
//                                 Он будет привязан к Вашей лицензии и будет использовать Ваши
//                                 настройки, но не сможет их редактировать.
//                             </DialogContentText>
//
//                             <Stack direction={'column'}>
//                                 <TextField label="Электронная почта"
//                                            variant="outlined"
//                                            size="small"
//                                            value={values.email}
//                                            sx={{mt: 1}}
//                                            type={'email'}
//                                            required={true}
//                                            onChange={
//                                                (event) => {
//                                                    setFieldValue('email', event.target.value)
//                                                }}
//                                            fullWidth/>
//
//                                 <TextField label="Пароль"
//                                            variant="outlined"
//                                            size="small"
//                                            value={values.password}
//                                            type={'password'}
//                                            required={true}
//                                            sx={{mt: 1}}
//                                            onChange={
//                                                (event) => {
//                                                    setFieldValue('password', event.target.value)
//                                                }}
//                                            fullWidth/>
//                             </Stack>
//                         </DialogContent>
//                         <DialogActions>
//                             <Button type={'submit'}>
//                                 Сохранить
//                             </Button>
//                             <Button onClick={() => {setOpenAddFriend(false)}
//                             }>
//                                 Закрыть
//                             </Button>
//                         </DialogActions>
//
//                     </Form>
//                 )}
//             </Formik>
//         </Dialog>
//     )
// }
//
// function ChangePasswordDialog({openChangePassword, setOpenChangePassword, friend, setOpenSuccess}) {
//     return(
//         <Dialog
//             open={openChangePassword}
//         >
//             <Formik initialValues={
//                 {
//                     newPassword: ''
//                 }
//             }
//                     validate={(values) => {
//                         // console.log(values)
//                     }}
//                     onSubmit={(values) => {
//                         setOpenChangePassword(false)
//                         // registerEmployee(values.email, values.password)
//                         setOpenSuccess(true)
//                     }}>
//                 {({setFieldValue, values}) => (
//                     <Form>
//                         <DialogTitle>
//                             Изменение пароля
//                         </DialogTitle>
//                         <DialogContent>
//                             <DialogContentText>
//                                 Введите новый пароль для сотрудника {friend}
//                             </DialogContentText>
//
//                             <Stack direction={'column'}>
//                                 <TextField label="Новый пароль"
//                                            variant="outlined"
//                                            size="small"
//                                            required={true}
//                                            value={values.newPassword}
//                                            sx={{mt: 1}}
//                                            onChange={
//                                                (event) => {
//                                                    setFieldValue('newPassword', event.target.value)
//                                                }}
//                                            fullWidth/>
//                             </Stack>
//                         </DialogContent>
//                         <DialogActions>
//                             <Button type={'submit'}>
//                                 Изменить
//                             </Button>
//                             <Button onClick={() => {setOpenChangePassword(false)}
//                             }>
//                                 Отмена
//                             </Button>
//                         </DialogActions>
//                     </Form>
//                 )}
//             </Formik>
//         </Dialog>
//     )
// }
//
// function SuccessDialog({openSuccess, setOpenSuccess, friend}) {
//     return (
//         <Dialog
//             open={openSuccess}
//         >
//             <DialogTitle>
//                 Изменение пароля
//             </DialogTitle>
//             <DialogContent>
//                 <DialogContentText>
//                     Пароль для сотрудника {friend} успешно изменен!
//                 </DialogContentText>
//             </DialogContent>
//             <DialogActions>
//                 <Button onClick={() => {setOpenSuccess(false)}
//                 }>
//                     Хорошо
//                 </Button>
//             </DialogActions>
//         </Dialog>
//     )
// }